import React, { Component } from "react";
import axios from "../axios";
import "./rule.scss";

var u = navigator.userAgent;
var isAndroid = u.indexOf("Android") > -1;
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

class enterpriseInformation extends React.Component {
    constructor(parameters) {
        super(parameters)
         this.state = {
            userId : "",
            companyName: "",
            companyNum : "",
            businessLicenseUrl : "",
            hostName : "",
         }
    };

     getUrlParam = (name) => {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = this.props.location.search.substr(1).match(reg);
        if (r != null) {
          return decodeURI(r[2]);
        }
        return ""; //如果此处只写return;则返回的是undefined
    };

    componentDidMount (){

        sessionStorage.setItem("Authorization",this.getUrlParam('tokenHead')+' '+this.getUrlParam('tokenCode'));
        sessionStorage.setItem("cAppVersion",this.getUrlParam('v'));
        let userId = this.getUrlParam('userId');
        let shopUserId = this.getUrlParam('shopUserId');
        const _this = this;
        axios
            .post("data/json/showCorporateAuthInfo",{userId : userId, shopUserId : shopUserId})
            .then(function (response){
                if (response.data.code === 10000) {
                    let resultObject = response.data.resultObject;
                    let companyName = resultObject.companyName;
                    let companyNum = resultObject.companyNum;
                    let businessLicenseUrl = resultObject.businessLicenseUrl;
                    let hostName = resultObject.hostName;

                    _this.setState({
                        userId : userId,
                        companyName : companyName,
                        companyNum : companyNum,
                        businessLicenseUrl : businessLicenseUrl,
                        hostName : hostName,
                    })
                }else {
                    let message = response.data.message;
                    Toast.show(message, 2);
                }
            })

            .catch(function (error) {
                console.log(error);
            });      
    }

    render() {
        return (
            <div className="enterpriseInformation_div">
                <br/>
                <p className="nametype_p">企业名称:  {this.state.companyName}</p>
                <br/>
                <p className="nametype_p">社会统一信用代码:  {this.state.companyNum}</p>
                 <br/>
                <p className="nametype_p">法定代表人姓名:  {this.state.hostName}</p>
                 <br/>
                <img className="businessLicense_img" src = {this.state.businessLicenseUrl} />
                  <br/>
                <p className="nametype_p">注：以上信息，由企业依据《电子商务法》规定发布公示。如需进一步核实，可联系企业咨询</p>
           </div>
        );
    }
}

export default enterpriseInformation;